// This file is auto-generated by @hey-api/openapi-ts
import { client } from './client.gen.js';
/**
 * Check if the service is alive and responding
 */
export const getHealth = (options) => (options?.client ?? client).get({ url: '/api/v1/monitoring/health', ...options });
/**
 * Check if the service is ready to accept traffic
 */
export const getHealthReady = (options) => (options?.client ?? client).get({ url: '/api/v1/monitoring/health/ready', ...options });
/**
 * Create document and get presigned upload URL
 */
export const createDocument = (options) => (options.client ?? client).post({
    url: '/api/v1/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a document
 *
 * Deletes document from storage and database
 */
export const deleteDocument = (options) => (options.client ?? client).delete({ url: '/api/v1/documents/{id}', ...options });
/**
 * Get document detail by id
 */
export const getDocument = (options) => (options.client ?? client).get({ url: '/api/v1/documents/{id}', ...options });
/**
 * Verify uploaded document
 */
export const verifyDocument = (options) => (options.client ?? client).patch({ url: '/api/v1/documents/{id}', ...options });
/**
 * Generate short-lived download URL
 */
export const getDocumentDownloadUrl = (options) => (options.client ?? client).post({ url: '/api/v1/documents/{id}/download', ...options });
/**
 * Create presigned URL for image upload
 *
 * @deprecated
 */
export const createImageUpload = (options) => (options.client ?? client).post({
    url: '/api/v1/images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Validate uploaded image and get public URL
 *
 * @deprecated
 */
export const completeImageUpload = (options) => (options.client ?? client).patch({ url: '/api/v1/images/{key}', ...options });
/**
 * Get startup configuration data
 *
 * Returns categories, product stages, raise stages, and status options for dropdowns
 *
 * @deprecated
 */
export const getStartupConfig = (options) => (options?.client ?? client).get({ url: '/api/v1/configs/startup', ...options });
/**
 * Get investor configuration data
 *
 * Returns investment areas and regions for investor profile dropdowns
 *
 * @deprecated
 */
export const getInvestorConfig = (options) => (options?.client ?? client).get({ url: '/api/v1/configs/investor', ...options });
/**
 * Get user's investor
 *
 * Get the investor associated with the current investor user
 *
 * @deprecated
 */
export const getInvestor = (options) => (options?.client ?? client).get({ url: '/api/v1/investors', ...options });
/**
 * Scrape LinkedIn profile data via Apify
 */
export const processLinkedIn = (options) => (options.client ?? client).post({
    url: '/api/v1/process/linkedin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Extract startup data from a pitch deck PDF
 */
export const processPitchDeck = (options) => (options.client ?? client).post({
    url: '/api/v1/process/pitch-deck',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Extract data from a website using AI
 */
export const processWebsite = (options) => (options.client ?? client).post({
    url: '/api/v1/process/website',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Create a new startup
 */
export const v2CreateStartup = (options) => (options.client ?? client).post({
    url: '/api/v2/startups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get startup overview dashboard
 */
export const v2GetStartupOverview = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/overview', ...options });
/**
 * Resolve the Home wizard focus state for a startup
 */
export const v2GetStartupHomeState = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/home-state', ...options });
/**
 * Get startup profile for data room
 */
export const v2GetStartupProfile = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/profile', ...options });
/**
 * Update startup profile
 */
export const v2UpdateStartupProfile = (options) => (options.client ?? client).patch({
    url: '/api/v2/startups/{startupId}/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get pitch overview for startup
 */
export const v2GetStartupPitch = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/pitch', ...options });
/**
 * Get startup credit balance
 */
export const v2GetStartupCreditBalance = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/credits/balance', ...options });
/**
 * List startup credit transactions
 */
export const v2ListStartupCredits = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/credits', ...options });
/**
 * Get analytics settings (exclusions)
 */
export const v2GetAnalyticsSettings = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/settings/analytics', ...options });
/**
 * Add an email or domain to the analytics exclusion list
 */
export const v2CreateAnalyticsExclusion = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/settings/analytics/exclusions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Remove an analytics exclusion entry
 */
export const v2DeleteAnalyticsExclusion = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/settings/analytics/exclusions/{exclusionId}', ...options });
/**
 * Get startup activity feed
 */
export const v2GetStartupFeed = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/feed', ...options });
/**
 * Get full pitch evaluation detail
 */
export const v2GetPitchEvaluation = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/evaluation/{evaluationId}', ...options });
/**
 * Get judge profile for a specific evaluation
 */
export const v2GetJudgeProfile = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/evaluation/{evaluationId}/judge/{judgeKey}', ...options });
/**
 * Get remaining feedback runs for the rolling week
 */
export const v2GetPrescreenAllowance = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/prescreen/allowance', ...options });
/**
 * Trigger prescreen for a pitch deck document
 */
export const v2TriggerPrescreen = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/prescreen/{documentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List team members
 */
export const v2ListTeamMembers = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/team', ...options });
/**
 * Create a team member
 */
export const v2CreateTeamMember = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/team',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Reorder team members
 */
export const v2ReorderTeamMembers = (options) => (options.client ?? client).put({
    url: '/api/v2/startups/{startupId}/team/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a team member
 */
export const v2DeleteTeamMember = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/team/{memberId}', ...options });
/**
 * Update a team member
 */
export const v2UpdateTeamMember = (options) => (options.client ?? client).patch({
    url: '/api/v2/startups/{startupId}/team/{memberId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Force re-scrape of a team member's LinkedIn profile
 */
export const v2RefreshTeamMemberLinkedIn = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/team/{memberId}/refresh-linkedin', ...options });
/**
 * Remove a startup member (owner only, cannot remove owners)
 */
export const v2RemoveAccess = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/access/{memberId}', ...options });
/**
 * List documents linked to a startup
 */
export const v2ListStartupDocuments = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/documents', ...options });
/**
 * Link a document to a startup
 */
export const v2LinkStartupDocument = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List every version of the startup documents, newest first, with dates
 */
export const v2ListStartupDocumentVersions = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/document-versions', ...options });
/**
 * Unlink a document from a startup
 */
export const v2UnlinkStartupDocument = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/documents/{documentId}', ...options });
/**
 * Update startup document label
 */
export const v2UpdateStartupDocument = (options) => (options.client ?? client).patch({
    url: '/api/v2/startups/{startupId}/documents/{documentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List startup memberships (users with access)
 */
export const v2ListAccess = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/access', ...options });
/**
 * List recommended investors for a startup
 */
export const v2ListStartupMatches = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/matches', ...options });
/**
 * Request a custom-persona evaluation against the latest pitch
 *
 * Resolves the most recent COMPLETED pitch session for the startup and creates an investor evaluation request against it. Idempotent.
 */
export const v2RequestStartupMatchEvaluation = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/matches/{investorId}/evaluate', ...options });
/**
 * Auto-unlock the top-rerank match for the startup (free, idempotent).
 *
 * On first call after the matcher has produced results, runs the same flow as "See their take" against the highest-rerank investor without consuming an evaluation credit. Subsequent calls no-op.
 */
export const v2AutoUnlockTopMatch = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/matches/auto-unlock', ...options });
/**
 * Record that the founder clicked through to an investor website
 *
 * Fire-and-forget: logs a Recombee CartAddition signal. Does not send any outbound communication.
 */
export const v2RecordStartupContactInvestor = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/matches/{investorId}/contact', ...options });
/**
 * Generate a personalized LinkedIn contact message for an investor GP
 */
export const v2GenerateInvestorContactMessage = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/matches/{investorId}/contact-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get saved outreach body message for a startup
 */
export const v2GetStartupOutreachBody = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/outreach-body', ...options });
/**
 * Save outreach body message for a startup
 */
export const v2UpdateStartupOutreachBody = (options) => (options.client ?? client).patch({
    url: '/api/v2/startups/{startupId}/outreach-body',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Record the founder explicit stealth/visible choice for a startup
 */
export const v2SetStartupStealthChoice = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/stealth-choice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Set which path the founder is on for reaching investors (self-share or outreach)
 */
export const v2SetDistributionIntent = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/distribution-intent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Snooze the Home Share step for 7 days
 */
export const v2SnoozeShareStep = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/home-state/snooze-share', ...options });
/**
 * Stamp the once-per-day cap on the post-improvement prompt
 */
export const v2MarkPostImprovementPromptShown = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/post-improvement-prompt/shown', ...options });
/**
 * List the investors actively following this startup (name, title, firm only)
 */
export const v2StartupListFollowers = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/followers', ...options });
/**
 * Remove an investor from this startup’s followers
 */
export const v2StartupRemoveFollower = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/followers/{observerId}', ...options });
/**
 * The startup’s updates address (made on first look), the updates received by email and what was held
 */
export const v2StartupGetEmailUpdates = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/email-updates', ...options });
/**
 * Take an update received by email off the profile
 */
export const v2StartupRemoveEmailUpdate = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/email-updates/{versionId}', ...options });
/**
 * Anonymous lines about how investors’ AI assistants used this record
 */
export const v2StartupGetAiReads = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/ai-reads', ...options });
/**
 * Create a new investor entity
 */
export const v2CreateInvestor = (options) => (options.client ?? client).post({
    url: '/api/v2/investors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get investor profile
 */
export const v2GetInvestorProfile = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/profile', ...options });
/**
 * Update investor profile
 */
export const v2UpdateInvestorProfile = (options) => (options.client ?? client).patch({
    url: '/api/v2/investors/{investorId}/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Set the signed-in person’s own title at this investor
 */
export const v2UpdateInvestorMember = (options) => (options.client ?? client).patch({
    url: '/api/v2/investors/{investorId}/member',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get investor persona status and brief
 */
export const v2GetInvestorPersona = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/persona', ...options });
/**
 * Get investor credit balance
 */
export const v2GetInvestorCreditBalance = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/credits/balance', ...options });
/**
 * List investor credit transactions
 */
export const v2ListInvestorCredits = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/credits', ...options });
/**
 * Get investor pitch feed
 */
export const v2GetInvestorFeed = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/feed', ...options });
/**
 * Get evaluation detail for investor
 */
export const v2GetInvestorEvaluation = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/evaluation/{evaluationId}', ...options });
/**
 * Get judge profile for investor evaluation
 */
export const v2GetInvestorJudgeProfile = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/evaluation/{evaluationId}/judge/{judgeKey}', ...options });
/**
 * Send connection request to startup from evaluation
 */
export const v2InvestorConnectWithStartup = (options) => (options.client ?? client).post({
    url: '/api/v2/investors/{investorId}/evaluation/{evaluationId}/connect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List all evaluation requests for investor
 */
export const v2ListInvestorEvaluationRequests = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/evaluation-requests', ...options });
/**
 * Request personalized evaluation
 *
 * Request a personalized evaluation using the investor custom persona.
 */
export const v2RequestInvestorEvaluation = (options) => (options.client ?? client).post({ url: '/api/v2/investors/{investorId}/pitches/{pitchSessionId}/investor-evaluation', ...options });
/**
 * Evaluate startup from investor perspective
 *
 * Triggers a custom evaluation for a startup. Uses the latest completed pitch session if available, otherwise falls back to prescreen using the pitch deck.
 */
export const v2EvaluateStartup = (options) => (options.client ?? client).post({ url: '/api/v2/investors/{investorId}/startups/{startupId}/evaluate', ...options });
/**
 * List the caller's own follows, with their own conditions
 */
export const v2InvestorListFollows = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/follows', ...options });
/**
 * Follow a startup for every major update or for a condition the investor names
 */
export const v2InvestorFollowStartup = (options) => (options?.client ?? client).post({
    url: '/api/v2/investor/follows',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});
/**
 * Stop following a startup
 */
export const v2InvestorUnfollowStartup = (options) => (options.client ?? client).delete({ url: '/api/v2/investor/follows/{startupId}', ...options });
/**
 * Change what a follow waits for, keeping everything else the follow holds
 */
export const v2InvestorEditFollow = (options) => (options.client ?? client).patch({
    url: '/api/v2/investor/follows/{startupId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Startups open to discovery, newest first, each marked with what it is to the investor
 */
export const v2InvestorBrowseStartups = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/startups', ...options });
/**
 * The founder invites the investor has made, newest first
 */
export const v2InvestorListFounderInvites = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/founder-invites', ...options });
/**
 * Ask a founder to join SeedForge; returns the invite link and a drafted message
 */
export const v2InvestorCreateFounderInvite = (options) => (options.client ?? client).post({
    url: '/api/v2/investor/founder-invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Remove an invite still waiting for its founder; its link stops working
 */
export const v2InvestorRemoveFounderInvite = (options) => (options.client ?? client).delete({ url: '/api/v2/investor/founder-invites/{inviteId}', ...options });
/**
 * What a founder sees on an invite link; one neutral 404 for an unknown, used or removed link
 */
export const v2FounderInvitesPreview = (options) => (options.client ?? client).get({ url: '/api/v2/founder-invites/{token}', ...options });
/**
 * A founder joins through an invite with one of their startups
 */
export const v2FounderInvitesClaim = (options) => (options.client ?? client).post({
    url: '/api/v2/founder-invites/{token}/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The watchdog: what it looks for, and the startups it has found for the investor
 */
export const v2InvestorGetWatchdog = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/watchdog', ...options });
/**
 * The investor's own focus (Settings), the same focus the watchdog shows
 */
export const v2InvestorGetFocus = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/focus', ...options });
/**
 * Save the investor's own focus; the watchdog's focus is the same list
 */
export const v2InvestorSaveFocus = (options) => (options?.client ?? client).put({
    url: '/api/v2/investor/focus',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});
/**
 * Pause or resume the watchdog; a paused watchdog keeps what it has shown
 */
export const v2InvestorSetWatchdogPaused = (options) => (options.client ?? client).put({
    url: '/api/v2/investor/watchdog/paused',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Mark a startup's watchdog match as seen, once the investor visits its data room
 */
export const v2InvestorMarkWatchdogStartupSeen = (options) => (options.client ?? client).post({ url: '/api/v2/investor/watchdog/startups/{startupId}/seen', ...options });
/**
 * Add something the watchdog should look for
 */
export const v2InvestorAddWatchdogCriterion = (options) => (options.client ?? client).post({
    url: '/api/v2/investor/watchdog/criteria',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Remove a criterion; the focus it came from stays as it is
 */
export const v2InvestorRemoveWatchdogCriterion = (options) => (options.client ?? client).delete({ url: '/api/v2/investor/watchdog/criteria/{criterionId}', ...options });
/**
 * Lock or unlock a criterion; a locked criterion stays until it is removed
 */
export const v2InvestorSetWatchdogCriterionLocked = (options) => (options.client ?? client).put({
    url: '/api/v2/investor/watchdog/criteria/{criterionId}/locked',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Search the startups open to the app by a phrase; quotes come only from a passed account check
 */
export const v2InvestorSearch = (options) => (options.client ?? client).post({
    url: '/api/v2/investor/searches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The investor’s most recent searches, newest first
 */
export const v2InvestorRecentSearches = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/searches/recent', ...options });
/**
 * Run a saved search again with the criteria it was saved with (nothing is counted)
 */
export const v2InvestorRestoreSearch = (options) => (options.client ?? client).get({ url: '/api/v2/investor/searches/{searchId}', ...options });
/**
 * Starting points from the investor’s focus, with how many startups each one shows now
 */
export const v2InvestorSearchSuggestions = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/search/suggestions', ...options });
/**
 * Use the criteria of a search as the investor’s locked watchdog focus
 */
export const v2InvestorFocusFromSearch = (options) => (options.client ?? client).post({
    url: '/api/v2/investor/focus/from-search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Not now: the focus offer is not asked again
 */
export const v2InvestorDismissFocusOffer = (options) => (options?.client ?? client).post({ url: '/api/v2/investor/focus/offer/dismiss', ...options });
/**
 * Reopen a startup the caller passed on: the pass is removed, nothing else changes
 */
export const v2InvestorReopenPass = (options) => (options.client ?? client).delete({ url: '/api/v2/investor/passes/{startupId}', ...options });
/**
 * Pass on a startup, with a reason and an optional “would look again when”. Never a follow.
 */
export const v2InvestorPass = (options) => (options.client ?? client).post({
    url: '/api/v2/investor/passes/{startupId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * A drafted message about a startup and the link the investor holds, to send to another investor
 */
export const v2InvestorShareStartup = (options) => (options.client ?? client).post({ url: '/api/v2/investor/startups/{startupId}/share', ...options });
/**
 * What one startup is to the investor: the follow and its state, updates since, the saved read and the pass
 */
export const v2InvestorGetStartupRelationship = (options) => (options.client ?? client).get({ url: '/api/v2/investor/startups/{startupId}/relationship', ...options });
/**
 * Save the investor's own note on a startup; empty text removes it
 */
export const v2InvestorSavePrivateNote = (options) => (options.client ?? client).put({
    url: '/api/v2/investor/startups/{startupId}/note',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete the caller's kept note on a startup, every version of it
 */
export const v2InvestorDeleteNote = (options) => (options.client ?? client).delete({ url: '/api/v2/investor/notes/{startupId}', ...options });
/**
 * The investor’s privacy switches for their AI assistant and alert emails
 */
export const v2InvestorGetMcpSettings = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/mcp-settings', ...options });
/**
 * Change the investor’s privacy switches (only what is sent changes)
 */
export const v2InvestorUpdateMcpSettings = (options) => (options?.client ?? client).patch({
    url: '/api/v2/investor/mcp-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});
/**
 * The investor’s alert inbox, newest first, with the unread count
 */
export const v2InvestorListNotifications = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/notifications', ...options });
/**
 * Mark notifications read (all, or the ids given)
 */
export const v2InvestorMarkNotificationsRead = (options) => (options?.client ?? client).post({
    url: '/api/v2/investor/notifications/read',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});
/**
 * The investor’s kept notes and passes
 */
export const v2InvestorListNotes = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/notes', ...options });
/**
 * Everything the investor owns in the AI assistant features, as one document
 */
export const v2InvestorExportMcpData = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/mcp-data/export', ...options });
/**
 * Delete everything the investor owns in the AI assistant features (the account stays)
 */
export const v2InvestorDeleteMcpData = (options) => (options.client ?? client).delete({
    url: '/api/v2/investor/mcp-data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The AI assistants the investor has signed in, with when each was last used
 */
export const v2InvestorListMcpConnections = (options) => (options?.client ?? client).get({ url: '/api/v2/investor/mcp-connections', ...options });
/**
 * Disconnect one AI assistant: its sign-in and tokens end
 */
export const v2InvestorDisconnectMcpConnection = (options) => (options.client ?? client).delete({ url: '/api/v2/investor/mcp-connections/{clientId}', ...options });
/**
 * Ask to be told when SeedForge is in ChatGPT’s app directory
 */
export const v2InvestorNotifyWhenInChatgpt = (options) => (options?.client ?? client).post({ url: '/api/v2/investor/chatgpt-notify', ...options });
/**
 * Get current user's profile data
 */
export const v2GetMe = (options) => (options?.client ?? client).get({ url: '/api/v2/user/me', ...options });
/**
 * Update current user's profile data
 *
 * Update user information including name, bio, location, and social links
 */
export const v2UpdateMe = (options) => (options?.client ?? client).patch({
    url: '/api/v2/user/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});
/**
 * Get all memberships (startups and investors) the current user belongs to
 */
export const v2GetMyMemberships = (options) => (options?.client ?? client).get({ url: '/api/v2/user/me/memberships', ...options });
/**
 * Get the Intercom Messenger identity verification JWT for the current user
 */
export const v2GetIntercomToken = (options) => (options?.client ?? client).get({ url: '/api/v2/user/me/intercom', ...options });
/**
 * Record acceptance of the current terms and privacy versions
 */
export const v2AcceptTerms = (options) => (options.client ?? client).post({
    url: '/api/v2/user/me/accept-terms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List pending invites for a startup
 */
export const v2ListStartupInvites = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/invites', ...options });
/**
 * Invite a user to a startup
 */
export const v2CreateStartupInvite = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Cancel a pending invite
 */
export const v2CancelStartupInvite = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/invites/{inviteId}', ...options });
/**
 * List pending invites for an investor
 */
export const v2ListInvestorInvites = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/invites', ...options });
/**
 * Invite a user to an investor organization
 */
export const v2CreateInvestorInvite = (options) => (options.client ?? client).post({
    url: '/api/v2/investors/{investorId}/invites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Cancel a pending investor invite
 */
export const v2CancelInvestorInvite = (options) => (options.client ?? client).delete({ url: '/api/v2/investors/{investorId}/invites/{inviteId}', ...options });
/**
 * Look up invite details by token
 */
export const v2LookupInvite = (options) => (options.client ?? client).get({ url: '/api/v2/invites/{token}', ...options });
/**
 * Accept a team invite
 */
export const v2AcceptInvite = (options) => (options.client ?? client).post({
    url: '/api/v2/invites/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Create pitch session
 */
export const v2CreatePitch = (options) => (options.client ?? client).post({
    url: '/api/v2/pitches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get pitch session
 */
export const v2GetPitch = (options) => (options.client ?? client).get({ url: '/api/v2/pitches/{pitchId}', ...options });
/**
 * Update pitch session
 */
export const v2UpdatePitch = (options) => (options.client ?? client).patch({
    url: '/api/v2/pitches/{pitchId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Start pitch session
 */
export const v2StartPitch = (options) => (options.client ?? client).post({ url: '/api/v2/pitches/{pitchId}/start', ...options });
/**
 * Finish pitch session
 */
export const v2FinishPitch = (options) => (options.client ?? client).post({ url: '/api/v2/pitches/{pitchId}/finish', ...options });
/**
 * Get pitch video URL
 */
export const v2GetPitchVideoUrl = (options) => (options.client ?? client).post({ url: '/api/v2/pitches/{pitchId}/video-url', ...options });
/**
 * List share links for a startup
 */
export const v2ListShareLinks = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/share-links', ...options });
/**
 * Create a new share link
 */
export const v2CreateShareLink = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/share-links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a share link
 */
export const v2DeleteShareLink = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{startupId}/share-links/{linkId}', ...options });
/**
 * Update a share link
 */
export const v2UpdateShareLink = (options) => (options.client ?? client).patch({
    url: '/api/v2/startups/{startupId}/share-links/{linkId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get public profile preview by share link token
 */
export const v2GetPublicProfilePreview = (options) => (options.client ?? client).get({ url: '/api/v2/public/profile/{token}', ...options });
/**
 * Record an investor door submission (agent brief or thesis fit)
 */
export const v2JoinAgentWaitlist = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/agent-waitlist',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Register as a profile visitor with email
 */
export const v2RegisterProfileVisitor = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get full public startup profile by share link token
 */
export const v2GetPublicProfileFull = (options) => (options.client ?? client).get({ url: '/api/v2/public/profile/{token}/full', ...options });
/**
 * Send a heartbeat for profile viewing analytics
 */
export const v2ProfileHeartbeat = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Track a profile interaction event (click, document open/close)
 */
export const v2ProfileTrackEvent = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Track multiple profile events in a single request (for page unload)
 */
export const v2ProfileTrackEventBatch = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Ask a question about the profile (Server-Sent Events)
 */
export const v2ProfileChat = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Ask a question about your own profile (Server-Sent Events)
 */
export const v2ProfileChatPreview = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{startupId}/chat/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get the sources the chat would read on your own profile
 */
export const v2ProfileChatPreviewContext = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/chat/preview/context', ...options });
/**
 * Get the sources and remaining questions for the profile chat
 */
export const v2ProfileChatContext = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/chat/context',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get the prior turns of one chat session, for a page reload
 */
export const v2ProfileChatHistory = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/chat/history',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get a presigned download URL for a public profile document
 */
export const v2PublicDocumentDownload = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/documents/{documentId}/download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get a presigned URL for the pitch recording video
 */
export const v2PublicVideoUrl = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/video-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Send a connection request message to the startup founder
 */
export const v2ContactFounder = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Submit or remove a thumbs up/down reaction on a statement
 */
export const v2SubmitStatementReaction = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/reaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Record the visitor's interest-gate verdict on a share link
 */
export const v2SubmitInterestDecision = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/interest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get all statement reactions for a visitor
 */
export const v2GetStatementReactions = (options) => (options.client ?? client).get({ url: '/api/v2/public/profile/{token}/reactions', ...options });
/**
 * Submit agree/disagree feedback on selected text
 */
export const v2SubmitTextFeedback = (options) => (options.client ?? client).post({
    url: '/api/v2/public/profile/{token}/text-feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get anonymized founder analytics for a startup
 */
export const v2GetStartupAnalytics = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/analytics', ...options });
/**
 * Get the latest AI engagement report
 */
export const v2GetInsightsReport = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/analytics/insights', ...options });
/**
 * Generate AI-powered engagement report from investor behavior
 */
export const v2GenerateAnalyticsInsights = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{startupId}/analytics/insights', ...options });
/**
 * Get public investor profile by slug
 */
export const v2GetPublicInvestorBySlug = (options) => (options.client ?? client).get({ url: '/api/v2/public/investors/{slug}', ...options });
/**
 * Get website stats
 *
 * Returns aggregate counts used on the marketing landing page
 */
export const v2GetWebsiteStats = (options) => (options?.client ?? client).get({ url: '/api/v2/public/stats', ...options });
/**
 * Unsubscribe confirmation page (first click)
 */
export const v2UnsubscribePage = (options) => (options.client ?? client).get({ url: '/api/v2/unsubscribe', ...options });
/**
 * Confirm unsubscribe (second click — form submit from the page)
 */
export const v2UnsubscribeConfirm = (options) => (options.client ?? client).post({ url: '/api/v2/unsubscribe', ...options });
/**
 * Record a website visitor's cookie choice (proof of consent)
 */
export const v2CreateConsentLog = (options) => (options.client ?? client).post({
    url: '/api/v2/consent-log',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Submit user feedback (general or evaluation)
 */
export const v2CreateFeedback = (options) => (options.client ?? client).post({
    url: '/api/v2/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Aggregate product metrics for the admin dashboard
 */
export const v2AdminGetDashboard = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/dashboard', ...options });
/**
 * List all users (admin)
 */
export const v2AdminListUsers = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/users', ...options });
/**
 * Delete user and associated data (admin)
 */
export const v2AdminDeleteUser = (options) => (options.client ?? client).delete({
    url: '/api/v2/admin/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get user by ID (admin)
 */
export const v2AdminGetUserById = (options) => (options.client ?? client).get({ url: '/api/v2/admin/users/{id}', ...options });
/**
 * List every acceptance of the terms and privacy versions for a user (admin)
 */
export const v2AdminListUserTermsAcceptances = (options) => (options.client ?? client).get({ url: '/api/v2/admin/users/{id}/terms-acceptances', ...options });
/**
 * Get user memberships (startups and investors)
 */
export const v2AdminGetUserMemberships = (options) => (options.client ?? client).get({ url: '/api/v2/admin/users/{id}/memberships', ...options });
/**
 * Get user deletion preview (admin)
 */
export const v2AdminGetUserDeletionPreview = (options) => (options.client ?? client).get({ url: '/api/v2/admin/users/{id}/deletion-preview', ...options });
/**
 * Get startup deletion preview (admin)
 */
export const v2AdminGetStartupDeletionPreview = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/deletion-preview', ...options });
/**
 * Delete startup and associated data (admin)
 */
export const v2AdminDeleteStartup = (options) => (options.client ?? client).delete({
    url: '/api/v2/admin/startups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get startup by ID (admin)
 */
export const v2AdminGetStartupById = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}', ...options });
/**
 * Change a user login email (admin)
 */
export const v2AdminChangeUserEmail = (options) => (options.client ?? client).patch({
    url: '/api/v2/admin/users/{id}/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List all startups (admin)
 */
export const v2AdminListStartups = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/startups', ...options });
/**
 * Set the daily profile-chat answer ceiling for a startup (null = default)
 */
export const v2AdminSetStartupProfileChatLimit = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/startups/{id}/profile-chat-limit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List investor account checks by status, oldest first
 */
export const v2AdminListInvestorChecks = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/investor-checks', ...options });
/**
 * Pass or fail one investor account check; the first pass may award a founding place
 */
export const v2AdminDecideInvestorCheck = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/investor-checks/{membershipId}/decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List the dated facts on a startup record, current or historic
 */
export const v2AdminListStartupFacts = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/facts', ...options });
/**
 * A startup's updates address, the updates received by email and the mail held
 */
export const v2AdminGetStartupEmailUpdates = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/email-updates', ...options });
/**
 * List the documents and sessions the fact scan reads, with scan status
 */
export const v2AdminListStartupFactSources = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/fact-sources', ...options });
/**
 * Queue one source for another fact scan
 */
export const v2AdminRescanStartupFactSource = (options) => (options.client ?? client).post({ url: '/api/v2/admin/startups/{id}/fact-sources/{changeId}/rescan', ...options });
/**
 * Mark a startup as SeedForge's own test or demo startup (never discoverable)
 */
export const v2AdminSetStartupInternal = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/startups/{id}/internal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List startup credit transactions (admin)
 */
export const v2AdminListStartupCredits = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/credits', ...options });
/**
 * Add credits to startup (admin)
 */
export const v2AdminAddStartupCredits = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/startups/{id}/credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get pay-as-you-go billing status for a startup (admin)
 */
export const v2AdminGetStartupBilling = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/billing', ...options });
/**
 * Grant free prepaid sessions or evaluations to a startup (admin)
 */
export const v2AdminGrantStartupUsage = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/startups/{id}/billing/grant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a startup unconsumed prepaid usage units (admin reset)
 */
export const v2AdminResetStartupGrants = (options) => (options.client ?? client).post({ url: '/api/v2/admin/startups/{id}/billing/grants/reset', ...options });
/**
 * Get documents for a startup (admin)
 */
export const v2AdminGetStartupDocuments = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{startupId}/documents', ...options });
/**
 * Get startup memberships (admin)
 */
export const v2AdminGetStartupMemberships = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/memberships', ...options });
/**
 * Get startup team members (admin)
 */
export const v2AdminGetStartupTeamMembers = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/team-members', ...options });
/**
 * List recommended investors for a startup (admin)
 */
export const v2AdminListStartupMatches = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/matches', ...options });
/**
 * Get outreach status for a startup (admin)
 */
export const v2AdminGetStartupOutreachStatus = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/outreach', ...options });
/**
 * Get HeyReach campaign/sender/invitation debug fields for a startup (admin)
 */
export const v2AdminGetStartupOutreachHeyReachDebug = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/outreach/heyreach', ...options });
/**
 * Force-disconnect a live outreach campaign after confirming its HeyReach workspace was deleted, blocking recreation
 */
export const v2AdminForceDisconnectStartupOutreach = (options) => (options.client ?? client).post({ url: '/api/v2/admin/startups/{id}/outreach/force-disconnect', ...options });
/**
 * Get outreach KPI/funnel/last-sync for a startup (admin)
 */
export const v2AdminGetStartupOutreachOverview = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/outreach/overview', ...options });
/**
 * Get portfolio outreach status for a startup (admin)
 */
export const v2AdminGetStartupPortfolioOutreachStatus = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/outreach/portfolio/status', ...options });
/**
 * Get portfolio outreach queue for a startup (admin)
 */
export const v2AdminGetStartupPortfolioOutreachQueue = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/outreach/portfolio/queue', ...options });
/**
 * Pass-through to engine outreach/contacts feed (admin export source)
 */
export const v2AdminGetStartupOutreachContacts = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/outreach/contacts', ...options });
/**
 * Regenerate one or more of msg1/msg2/msg3 independently via per-message Langfuse prompts.
 */
export const v2AdminRegenerateContactMessage = (options) => (options.client ?? client).post({ url: '/api/v2/admin/outreach/messages/{messageId}/regenerate', ...options });
/**
 * Regenerate one or more of the per-startup msg1/msg2/msg3 sequence independently.
 */
export const v2AdminRegenerateStartupMessages = (options) => (options.client ?? client).post({ url: '/api/v2/admin/outreach/startups/{startupId}/messages/regenerate', ...options });
/**
 * Regenerate one or more of the per-startup portfolio msg1/msg2/msg3 sequence.
 */
export const v2AdminRegeneratePortfolioMessages = (options) => (options.client ?? client).post({ url: '/api/v2/admin/portfolio/startups/{startupId}/messages/regenerate', ...options });
/**
 * Get the latest matcher refresh request for a startup (admin)
 */
export const v2AdminGetStartupMatchesRefreshStatus = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/matches/refresh', ...options });
/**
 * Enqueue a matcher refresh for a startup (admin)
 *
 * Inserts a PENDING StartupMatchRefreshRequest. The engine scheduler picks it up and runs the matcher pipeline. Idempotent: if a request is already PENDING/PROCESSING, returns it.
 */
export const v2AdminRefreshStartupMatches = (options) => (options.client ?? client).post({ url: '/api/v2/admin/startups/{id}/matches/refresh', ...options });
/**
 * Schedule LinkedIn scrape for all team members missing raw data (admin)
 *
 * Finds team members with a LinkedIn URL but no rawLinkedInData (and not already SCRAPING) and triggers an async scrape for each. Returns immediately with the count of scheduled scrapes. Progress is visible via linkedinScrapeStatus on each member.
 */
export const v2AdminBackfillTeamMemberLinkedIn = (options) => (options?.client ?? client).post({ url: '/api/v2/admin/team-members/backfill-linkedin', ...options });
/**
 * List all investors (admin)
 */
export const v2AdminListInvestors = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/investors', ...options });
/**
 * Get investor by ID (admin)
 */
export const v2AdminGetInvestorById = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}', ...options });
/**
 * Update investor type / inactive-until (admin)
 */
export const v2AdminUpdateInvestor = (options) => (options.client ?? client).patch({
    url: '/api/v2/admin/investors/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List proposed investor/contact outreach exclusions (admin)
 */
export const v2AdminListInvestorUpdateProposals = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/investor-update-proposals', ...options });
/**
 * Approve or reject an investor update proposal (admin)
 */
export const v2AdminDecideInvestorUpdateProposal = (options) => (options.client ?? client).patch({
    url: '/api/v2/admin/investor-update-proposals/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Pause or resume one contact's outreach (admin)
 */
export const v2AdminPauseInvestorContact = (options) => (options.client ?? client).patch({
    url: '/api/v2/admin/investor-contacts/{id}/pause',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List deal flow pass/connect actions for an investor
 */
export const v2AdminListInvestorDealFlowInteractions = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}/deal-flow-interactions', ...options });
/**
 * List deal flow pass/connect actions investors made on a startup
 */
export const v2AdminListStartupDealFlowInteractions = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/deal-flow-interactions', ...options });
/**
 * List persisted deal-flow startup matches for an investor (admin)
 */
export const v2AdminListInvestorDealFlowMatches = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}/deal-flow-matches', ...options });
/**
 * Enqueue a deal-flow matches refresh request for an investor
 */
export const v2AdminRefreshInvestorDealFlowMatches = (options) => (options.client ?? client).post({ url: '/api/v2/admin/investors/{id}/deal-flow-matches/refresh', ...options });
/**
 * Send a test deal-flow digest email to all investor team members
 */
export const v2AdminSendInvestorDealFlowDigest = (options) => (options.client ?? client).post({ url: '/api/v2/admin/investors/{id}/deal-flow-matches/send-digest', ...options });
/**
 * List free-form investor preference values not in the canonical enums
 */
export const v2AdminListUnknownInvestorPreferences = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/investors/unknown-preferences', ...options });
/**
 * Apply an admin-provided dictionary + drop unknowns across all investor preferences. Dry-run by default.
 */
export const v2AdminNormalizeInvestorPreferences = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/investors/normalize-preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get investor persona with metric prompts (admin)
 */
export const v2AdminGetInvestorPersona = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}/persona', ...options });
/**
 * Trigger persona research for investor (admin)
 */
export const v2AdminTriggerPersonaResearch = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/investors/{id}/persona/research',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Trigger activity research for investor (admin)
 */
export const v2AdminTriggerActivityResearch = (options) => (options.client ?? client).post({ url: '/api/v2/admin/investors/{id}/activity-research', ...options });
/**
 * List all activity research jobs (admin)
 */
export const v2AdminListActivityResearch = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/investors/activity-research', ...options });
/**
 * List all persona research jobs (admin)
 */
export const v2AdminListPersonaResearch = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/investors/persona-research', ...options });
/**
 * Trigger portfolio research for investor (admin)
 */
export const v2AdminTriggerPortfolioResearch = (options) => (options.client ?? client).post({ url: '/api/v2/admin/investors/{id}/portfolio-research', ...options });
/**
 * List portfolio research jobs (admin)
 */
export const v2AdminListPortfolioResearch = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/investors/portfolio-research', ...options });
/**
 * Get portfolio companies and contacts for investor (admin)
 */
export const v2AdminGetInvestorPortfolioCompanies = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}/portfolio-companies', ...options });
/**
 * Per-startup outcomes by outreach copy arm, with excluded counts
 */
export const v2AdminGetOutreachCopyArms = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/copy-arms', ...options });
/**
 * Every live message variant for a startup, both campaigns
 */
export const v2AdminGetStartupOutreachVariants = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/outreach/variants', ...options });
/**
 * List open portfolio warm-intro candidates for confirmation
 */
export const v2AdminGetWarmIntroCandidates = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/warm-intro-candidates', ...options });
/**
 * List outreach reply classification jobs (admin)
 */
export const v2AdminListOutreachReplyClassification = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/reply-classification', ...options });
/**
 * Global reply classification stats for all startups (7d/30d)
 */
export const v2AdminGetOutreachReplyStats = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/reply-classification/stats', ...options });
/**
 * Read the live LinkedIn conversation for a message (admin, never stored)
 */
export const v2AdminGetOutreachMessageConversation = (options) => (options.client ?? client).get({ url: '/api/v2/admin/outreach/messages/{messageId}/conversation', ...options });
/**
 * Rerun a reply classification job (admin)
 */
export const v2AdminRerunOutreachReplyClassification = (options) => (options.client ?? client).post({ url: '/api/v2/admin/outreach/reply-classification/{messageId}/rerun', ...options });
/**
 * Rerun a portfolio reply classification job (admin)
 */
export const v2AdminRerunPortfolioOutreachReplyClassification = (options) => (options.client ?? client).post({ url: '/api/v2/admin/outreach/reply-classification/portfolio/{portfolioMessageId}/rerun', ...options });
/**
 * List all matcher refresh jobs across startups (admin)
 */
export const v2AdminListMatcherJobs = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/matcher-jobs', ...options });
/**
 * List investor credit transactions (admin)
 */
export const v2AdminListInvestorCredits = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}/credits', ...options });
/**
 * Add credits to investor (admin)
 */
export const v2AdminAddInvestorCredits = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/investors/{id}/credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get investor memberships (admin)
 */
export const v2AdminGetInvestorMemberships = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}/memberships', ...options });
/**
 * List all evaluations (pitch + prescreen) unified
 */
export const v2AdminListEvaluations = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/evaluations', ...options });
/**
 * Get evaluation in view format (same as founder detail)
 */
export const v2AdminGetEvaluationView = (options) => (options.client ?? client).get({ url: '/api/v2/admin/evaluations/{id}/view', ...options });
/**
 * Get single evaluation raw details with research data
 */
export const v2AdminGetEvaluationDetails = (options) => (options.client ?? client).get({ url: '/api/v2/admin/evaluations/{id}/details', ...options });
/**
 * Get judge profile for an evaluation (admin)
 */
export const v2AdminGetJudgeProfile = (options) => (options.client ?? client).get({ url: '/api/v2/admin/evaluations/{evaluationId}/judge/{judgeKey}', ...options });
/**
 * Regenerate evaluation for a pitch session (admin)
 */
export const v2AdminRegenerateEvaluation = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/evaluations/{id}/regenerate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Rerun prescreen with a selected document (admin)
 */
export const v2AdminRerunPrescreen = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/prescreens/{id}/rerun',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Trigger a prescreen for a startup with a linked pitch deck (admin)
 */
export const v2AdminTriggerPrescreen = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/prescreens/trigger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a prescreen request and its evaluations (admin)
 */
export const v2AdminDeletePrescreen = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/prescreens/{id}', ...options });
/**
 * Delete a pitch session and all its evaluations (admin)
 */
export const v2AdminDeletePitchSession = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/pitch-sessions/{id}', ...options });
/**
 * Delete a single evaluation (admin)
 */
export const v2AdminDeleteEvaluation = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/evaluations/{id}', ...options });
/**
 * List all data rooms (admin)
 */
export const v2AdminListDataRooms = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/data-rooms', ...options });
/**
 * Get data room by ID with content (admin)
 */
export const v2AdminGetDataRoomById = (options) => (options.client ?? client).get({ url: '/api/v2/admin/data-rooms/{id}', ...options });
/**
 * Get data room analytics (admin)
 */
export const v2AdminGetDataRoomAnalytics = (options) => (options.client ?? client).get({ url: '/api/v2/admin/data-rooms/{id}/analytics', ...options });
/**
 * List latest AI insight reports per startup (admin)
 */
export const v2AdminListAiInsightReports = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/ai-insights', ...options });
/**
 * Manually regenerate the AI insight report for a startup (admin)
 */
export const v2AdminRegenerateAiInsightReport = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/ai-insights/regenerate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List text highlight feedbacks for a startup
 */
export const v2AdminListStartupTextFeedbacks = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/text-feedbacks', ...options });
/**
 * List statement reactions (agree/disagree) for a startup
 */
export const v2AdminListStartupReactions = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{id}/reactions', ...options });
/**
 * List profile chat conversations (admin)
 */
export const v2AdminListProfileChats = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/profile-chats', ...options });
/**
 * Get one profile chat conversation with every turn (admin)
 */
export const v2AdminGetProfileChatById = (options) => (options.client ?? client).get({ url: '/api/v2/admin/profile-chats/{conversationId}', ...options });
/**
 * Everything the model received for one profile chat turn (admin)
 */
export const v2AdminGetProfileChatTurnContext = (options) => (options.client ?? client).get({ url: '/api/v2/admin/profile-chats/{conversationId}/turns/{turnId}/context', ...options });
/**
 * Drop the question text of one profile chat turn (admin)
 */
export const v2AdminRedactProfileChatTurn = (options) => (options.client ?? client).post({ url: '/api/v2/admin/profile-chats/{conversationId}/turns/{turnId}/redact', ...options });
/**
 * List all feedback (admin)
 */
export const v2AdminListFeedback = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/feedback', ...options });
/**
 * List all automated emails (admin)
 */
export const v2AdminListAutomatedEmails = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/automated-emails', ...options });
/**
 * Get automated email by ID (admin)
 */
export const v2AdminGetAutomatedEmailById = (options) => (options.client ?? client).get({ url: '/api/v2/admin/automated-emails/{id}', ...options });
/**
 * Manually send a pending automated email (admin)
 */
export const v2AdminSendAutomatedEmail = (options) => (options.client ?? client).post({ url: '/api/v2/admin/automated-emails/{id}/send', ...options });
/**
 * List entitlements for a startup (history + status)
 */
export const v2AdminListStartupEntitlements = (options) => (options.client ?? client).get({ url: '/api/v2/admin/startups/{startupId}/entitlements', ...options });
/**
 * Grant a non-consumable entitlement to a startup (no Stripe activity)
 */
export const v2AdminGrantStartupEntitlement = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/startups/{startupId}/entitlements',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Revoke an entitlement (audit-only; refund the Stripe charge separately if PURCHASE)
 */
export const v2AdminRevokeStartupEntitlement = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/startups/{startupId}/entitlements/{entitlementId}/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List outreach rows awaiting campaign clone
 */
export const v2AdminListPendingOutreach = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/pending', ...options });
/**
 * List live outreach campaigns whose HeyReach sending limits are not yet confirmed
 */
export const v2AdminListOutreachLimitsPending = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/limits-pending', ...options });
/**
 * Confirm the HeyReach sending limits are set; stamps limitsUpdatedAt
 */
export const v2AdminMarkOutreachLimitsSet = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/outreach/{id}/limits-set',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List pending founder outreach wallet withdrawal requests
 */
export const v2AdminListOutreachWithdrawalRequests = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/withdrawal-requests', ...options });
/**
 * Mark a withdrawal request resolved once the refund is processed
 */
export const v2AdminResolveOutreachWithdrawalRequest = (options) => (options.client ?? client).post({ url: '/api/v2/admin/outreach/withdrawal-requests/{id}/resolve', ...options });
/**
 * List startups using outreach (provisioned seats)
 */
export const v2AdminListOutreachSeatQueue = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/seat-queue', ...options });
/**
 * Force-promote a PENDING_SEAT outreach (bypasses cap)
 */
export const v2AdminPromoteOutreachSeat = (options) => (options.client ?? client).post({ url: '/api/v2/admin/outreach/{id}/promote', ...options });
/**
 * Force a single-row sender/campaign re-poll
 */
export const v2AdminRecheckOutreach = (options) => (options.client ?? client).post({ url: '/api/v2/admin/outreach/{id}/recheck', ...options });
/**
 * Reclaim an outreach seat (pause + remove member)
 */
export const v2AdminEjectOutreachSeat = (options) => (options.client ?? client).post({ url: '/api/v2/admin/outreach/{id}/eject', ...options });
/**
 * List outreach rows stuck in AWAITING_SENDER for over 2 weeks
 */
export const v2AdminListStuckAwaitingSenderOutreach = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/stuck-senders', ...options });
/**
 * Per-startup match quality and interaction breakdown for outreach
 */
export const v2AdminListOutreachStartupMetrics = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/startup-metrics', ...options });
/**
 * Live-check HeyReach to confirm a stuck workspace was manually deleted
 */
export const v2AdminRecheckOutreachWorkspaceRemoved = (options) => (options.client ?? client).post({ url: '/api/v2/admin/outreach/{id}/workspace/recheck', ...options });
/**
 * Clear a stuck outreach workspace after confirming its HeyReach workspace was deleted, blocking recreation
 */
export const v2AdminResetStuckOutreachWorkspace = (options) => (options.client ?? client).post({ url: '/api/v2/admin/outreach/{id}/workspace/reset', ...options });
/**
 * List replies flagged by the LLM as potential booked calls or investor warm intros (admin must decide)
 */
export const v2AdminListOutreachCallCandidates = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/call-candidates', ...options });
/**
 * List outreach messages eligible for manual call booking
 */
export const v2AdminListManualCallBookingCandidates = (options) => (options.client ?? client).get({ url: '/api/v2/admin/outreach/manual-call-booking/candidates', ...options });
/**
 * List all outreach campaigns with wallet + spend summary
 */
export const v2AdminListOutreachBilling = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/outreach/billing', ...options });
/**
 * Outreach billing detail for one startup (transactions + accruals)
 */
export const v2AdminGetOutreachBillingDetail = (options) => (options.client ?? client).get({ url: '/api/v2/admin/outreach/billing/{id}', ...options });
/**
 * Issue a manual outreach refund or balance adjustment
 */
export const v2AdminCreateOutreachCreditTransaction = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/outreach/credit-transactions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Confirm or dismiss an LLM-flagged call candidate
 */
export const v2AdminOutreachCallDecision = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/outreach/messages/{messageId}/call-decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * The thesis each member of an investor's firm set through their AI assistant
 */
export const v2AdminGetInvestorThesis = (options) => (options.client ?? client).get({ url: '/api/v2/admin/investors/{id}/thesis', ...options });
/**
 * Pin an investor to one MCP text set (null routes on the app again)
 */
export const v2AdminSetMcpTextSet = (options) => (options.client ?? client).patch({
    url: '/api/v2/admin/users/{userId}/mcp-text-set',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List investor follows with state and classification, never their words
 */
export const v2AdminListObservers = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/observers', ...options });
/**
 * The founder statements that fired a follow's alerts, never the investor's words
 */
export const v2AdminListObserverAlerts = (options) => (options.client ?? client).get({ url: '/api/v2/admin/observers/{observerId}/alerts', ...options });
/**
 * Investor AI call metrics, sessions and engine job health (never arguments)
 */
export const v2AdminAgentOverview = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/agent', ...options });
/**
 * Every app that has called the MCP, with its first-seen date and latest text set
 */
export const v2AdminAgentClients = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/agent/clients', ...options });
/**
 * The calls of one agent session: tool, latency, status, refusal, time
 */
export const v2AdminAgentSessionCalls = (options) => (options.client ?? client).get({ url: '/api/v2/admin/agent/sessions/{sessionId}/calls', ...options });
/**
 * List all blog posts (admin)
 */
export const v2AdminListBlogPosts = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/blog-posts', ...options });
/**
 * Create a new blog post
 */
export const v2AdminCreateBlogPost = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/blog-posts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a blog post
 */
export const v2AdminDeleteBlogPost = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/blog-posts/{id}', ...options });
/**
 * Get blog post by ID (admin)
 */
export const v2AdminGetBlogPost = (options) => (options.client ?? client).get({ url: '/api/v2/admin/blog-posts/{id}', ...options });
/**
 * Update a blog post
 */
export const v2AdminUpdateBlogPost = (options) => (options.client ?? client).put({
    url: '/api/v2/admin/blog-posts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List published blog posts
 */
export const v2ListPublishedBlogPosts = (options) => (options?.client ?? client).get({ url: '/api/v2/blog-posts', ...options });
/**
 * Get a published blog post by slug
 */
export const v2GetPublishedBlogPost = (options) => (options.client ?? client).get({ url: '/api/v2/blog-posts/{slug}', ...options });
/**
 * Publish a certified Active Investor Index feed
 */
export const v2AdminPublishInvestorIndex = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/investor-index/publications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Page counts and recent publications of the Active Investor Index
 */
export const v2AdminGetInvestorIndexStatus = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/investor-index/status', ...options });
/**
 * List published Active Investor Index pages (summaries only)
 */
export const v2ListInvestorIndexPages = (options) => (options?.client ?? client).get({ url: '/api/v2/investor-index/pages', ...options });
/**
 * Get one published Active Investor Index page by key
 */
export const v2GetInvestorIndexPage = (options) => (options.client ?? client).get({ url: '/api/v2/investor-index/pages/{pageKey}', ...options });
/**
 * List all automated email templates
 */
export const v2AdminListEmailTemplates = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/email-templates', ...options });
/**
 * Get an email template by type
 */
export const v2AdminGetEmailTemplate = (options) => (options.client ?? client).get({ url: '/api/v2/admin/email-templates/{type}', ...options });
/**
 * Update an email template (subject, body, enabled)
 */
export const v2AdminUpdateEmailTemplate = (options) => (options.client ?? client).put({
    url: '/api/v2/admin/email-templates/{type}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Send a test render of an email template to the admin's own email
 */
export const v2AdminSendTestEmailTemplate = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/email-templates/{type}/test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Record where a new account came from (first touch, written once)
 */
export const v2RecordSignupSource = (options) => (options?.client ?? client).post({
    url: '/api/v2/user/me/signup-source',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});
/**
 * Record the answer to the sign-up question, or a skip (written once)
 */
export const v2RecordSignupAnswer = (options) => (options?.client ?? client).post({
    url: '/api/v2/user/me/signup-answer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});
/**
 * Get the sign-up question shown during onboarding
 */
export const v2GetSignupQuestion = (options) => (options?.client ?? client).get({ url: '/api/v2/signup-question', ...options });
/**
 * Get the sign-up question for editing
 */
export const v2AdminGetSignupQuestion = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/signup-question', ...options });
/**
 * Save the sign-up question (title, options, follow-ups, AI question)
 */
export const v2AdminUpdateSignupQuestion = (options) => (options.client ?? client).put({
    url: '/api/v2/admin/signup-question',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List help center categories with their articles
 */
export const v2AdminListHelpCategories = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/help-categories', ...options });
/**
 * Create a help center category
 */
export const v2AdminCreateHelpCategory = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/help-categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Reorder help center categories
 */
export const v2AdminReorderHelpCategories = (options) => (options.client ?? client).put({
    url: '/api/v2/admin/help-categories/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a help center category (must be empty)
 */
export const v2AdminDeleteHelpCategory = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/help-categories/{id}', ...options });
/**
 * Update a help center category
 */
export const v2AdminUpdateHelpCategory = (options) => (options.client ?? client).put({
    url: '/api/v2/admin/help-categories/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List published help categories with their articles
 */
export const v2ListPublishedHelpCategories = (options) => (options?.client ?? client).get({ url: '/api/v2/help-categories', ...options });
/**
 * Create a help center article
 */
export const v2AdminCreateHelpArticle = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/help-articles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Reorder help center articles within a category
 */
export const v2AdminReorderHelpArticles = (options) => (options.client ?? client).put({
    url: '/api/v2/admin/help-articles/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Delete a help center article
 */
export const v2AdminDeleteHelpArticle = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/help-articles/{id}', ...options });
/**
 * Get help center article by ID
 */
export const v2AdminGetHelpArticle = (options) => (options.client ?? client).get({ url: '/api/v2/admin/help-articles/{id}', ...options });
/**
 * Update a help center article
 */
export const v2AdminUpdateHelpArticle = (options) => (options.client ?? client).put({
    url: '/api/v2/admin/help-articles/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Search published help articles by title, description, and content
 */
export const v2SearchPublishedHelpArticles = (options) => (options?.client ?? client).get({ url: '/api/v2/help-articles/search', ...options });
/**
 * Get a published help article by slug
 */
export const v2GetPublishedHelpArticle = (options) => (options.client ?? client).get({ url: '/api/v2/help-articles/{slug}', ...options });
/**
 * Get pay-as-you-go balances for a startup
 */
export const v2GetBillingStatus = (options) => (options.client ?? client).get({ url: '/api/v2/billing/status', ...options });
/**
 * Get the investor’s current deal flow subscription status
 */
export const v2GetDealFlowSubscriptionStatus = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/deal-flow/subscription', ...options });
/**
 * Subscribe the investor to deal flow alerts
 */
export const v2SubscribeToDealFlow = (options) => (options.client ?? client).post({ url: '/api/v2/investors/{investorId}/deal-flow/subscribe', ...options });
/**
 * Unsubscribe the investor from deal flow alerts
 */
export const v2UnsubscribeFromDealFlow = (options) => (options.client ?? client).post({ url: '/api/v2/investors/{investorId}/deal-flow/unsubscribe', ...options });
/**
 * List startups currently matched into the investor’s deal flow
 */
export const v2ListDealFlowMatches = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/deal-flow/matches', ...options });
/**
 * List startups the investor has passed on or connected with
 */
export const v2ListDealFlowArchive = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/deal-flow/archive', ...options });
/**
 * Get a single deal flow match by startup id
 */
export const v2GetDealFlowMatch = (options) => (options.client ?? client).get({ url: '/api/v2/investors/{investorId}/deal-flow/matches/{startupId}', ...options });
/**
 * Generate short-lived URL for a deal flow startup’s pitch video
 */
export const v2GetDealFlowMatchVideoUrl = (options) => (options.client ?? client).post({ url: '/api/v2/investors/{investorId}/deal-flow/matches/{startupId}/video-url', ...options });
/**
 * Generate short-lived download URL for a deal flow startup’s document
 */
export const v2DownloadDealFlowMatchDocument = (options) => (options.client ?? client).post({ url: '/api/v2/investors/{investorId}/deal-flow/matches/{startupId}/documents/{documentId}/download', ...options });
/**
 * Investor passes on a deal flow startup
 */
export const v2PassDealFlowMatch = (options) => (options.client ?? client).post({
    url: '/api/v2/investors/{investorId}/deal-flow/matches/{startupId}/pass',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Investor sends a connect request to a deal flow startup
 */
export const v2ConnectDealFlowMatch = (options) => (options.client ?? client).post({
    url: '/api/v2/investors/{investorId}/deal-flow/matches/{startupId}/connect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List active entitlements for a startup (locked/unlocked state)
 */
export const v2GetActiveEntitlements = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{startupId}/entitlements/active', ...options });
/**
 * List all registered feature flags with their allowlists (admin)
 */
export const v2AdminListFeatureFlags = (options) => (options?.client ?? client).get({ url: '/api/v2/admin/feature-flags', ...options });
/**
 * Toggle the global enabled state of a feature flag (admin)
 */
export const v2AdminSetFeatureFlagEnabled = (options) => (options.client ?? client).patch({
    url: '/api/v2/admin/feature-flags/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Add a startup to a feature flag allowlist (admin)
 */
export const v2AdminAddFeatureFlagStartup = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/feature-flags/{key}/startups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Remove a startup from a feature flag allowlist (admin)
 */
export const v2AdminRemoveFeatureFlagStartup = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/feature-flags/{key}/startups/{startupId}', ...options });
/**
 * Add an investor to a feature flag allowlist (admin)
 */
export const v2AdminAddFeatureFlagInvestor = (options) => (options.client ?? client).post({
    url: '/api/v2/admin/feature-flags/{key}/investors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Remove an investor from a feature flag allowlist (admin)
 */
export const v2AdminRemoveFeatureFlagInvestor = (options) => (options.client ?? client).delete({ url: '/api/v2/admin/feature-flags/{key}/investors/{investorId}', ...options });
/**
 * Resolve feature flag values for a given startup
 */
export const v2GetStartupFeatureFlags = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/feature-flags', ...options });
/**
 * Which sign-in providers are currently available, besides the email code
 */
export const v2GetSignInProviders = (options) => (options?.client ?? client).get({ url: '/api/v2/public/sign-in-providers', ...options });
/**
 * Get outreach billing pricing (view + call costs, deposit options)
 */
export const v2GetOutreachPricing = (options) => (options?.client ?? client).get({ url: '/api/v2/outreach/pricing', ...options });
/**
 * Get outreach status for a startup
 */
export const v2GetStartupOutreachStatus = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach', ...options });
/**
 * Enable automated outreach for a startup
 */
export const v2EnableStartupOutreach = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/enable', ...options });
/**
 * Disable automated outreach for a startup
 */
export const v2DisableStartupOutreach = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/disable', ...options });
/**
 * Get the founder outreach messages (msg1/msg2/msg3) and approval state
 */
export const v2GetStartupOutreachMessages = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/messages', ...options });
/**
 * Update one or more founder outreach messages (msg1/msg2/msg3)
 */
export const v2UpdateStartupOutreachMessages = (options) => (options.client ?? client).patch({
    url: '/api/v2/startups/{id}/outreach/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Drop the founder edit for one message and use the generated version
 */
export const v2ResetStartupOutreachMessage = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{id}/outreach/messages/{field}/custom', ...options });
/**
 * Mark the founder outreach messages as reviewed (launch-checklist gate)
 */
export const v2ReviewStartupOutreachMessages = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/messages/review', ...options });
/**
 * Choose which outreach channels to run (Choose campaigns launch-checklist gate)
 */
export const v2SelectStartupOutreachChannels = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{id}/outreach/channels-selected',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Approve the founder messages and launch the outreach campaign
 */
export const v2LaunchStartupOutreach = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/launch', ...options });
/**
 * List the founder pre-launch approve/decline decisions for the preview board
 */
export const v2GetStartupOutreachContactDecisions = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/contact-decisions', ...options });
/**
 * Upsert one or more pre-launch contact approve/decline decisions
 */
export const v2SetStartupOutreachContactDecisions = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{id}/outreach/contact-decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * List contacts awaiting the founder approval, with investor profiles + messages
 */
export const v2GetStartupOutreachQueue = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/queue', ...options });
/**
 * Approve a queued contact — they will be contacted on the next send
 */
export const v2ApproveStartupOutreachQueued = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/queue/{leadId}/approve', ...options });
/**
 * Approve every contact still awaiting approval on the board
 */
export const v2ApproveAllStartupOutreachQueued = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/queue/approve-all', ...options });
/**
 * Skip every contact still awaiting approval, keeping them restorable
 */
export const v2SkipAllStartupOutreachQueued = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/queue/skip-all', ...options });
/**
 * Decline a queued contact — they will not be contacted (moves to archive)
 */
export const v2DeclineStartupOutreachQueued = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/queue/{leadId}/decline', ...options });
/**
 * Archive a finished (no-response) contact — moves it to the Archive page
 */
export const v2ArchiveStartupOutreachContact = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/queue/{leadId}/archive', ...options });
/**
 * Remove an in-progress lead from HeyReach and archive it — stops the sequence immediately
 */
export const v2RemoveStartupOutreachInProgressLead = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/queue/{leadId}/remove', ...options });
/**
 * List archived outreach contacts (declined + finished), with profiles + messages
 */
export const v2GetStartupOutreachArchive = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/archive', ...options });
/**
 * Restore an archived contact back onto the board
 */
export const v2RestoreStartupOutreachArchived = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/archive/{leadId}/restore', ...options });
/**
 * Get KPI, funnel, and reply-outcome breakdown for the dashboard
 */
export const v2GetStartupOutreachOverview = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/overview', ...options });
/**
 * Mark specific replies as read once the founder has actually seen them
 */
export const v2MarkRepliesSeen = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{id}/outreach/replies/seen',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get combined-campaign totals, daily series, and confirmed outcomes
 */
export const v2GetStartupOutreachOutcomes = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/outcomes', ...options });
/**
 * Remove the LinkedIn sender from HeyReach and reset outreach for re-setup
 */
export const v2RequestOutreachDisconnect = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/request-disconnect', ...options });
/**
 * Merged outreach activity timeline (campaign events + charges + topups)
 */
export const v2GetStartupOutreachActivity = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/activity', ...options });
/**
 * Get portfolio outreach status for a startup
 */
export const v2GetPortfolioOutreachStatus = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/portfolio', ...options });
/**
 * Enable portfolio outreach for a startup
 */
export const v2EnablePortfolioOutreach = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/portfolio/enable', ...options });
/**
 * Pause the portfolio outreach campaign
 */
export const v2PausePortfolioOutreach = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/portfolio/pause', ...options });
/**
 * Resume the portfolio outreach campaign
 */
export const v2ResumePortfolioOutreach = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/portfolio/resume', ...options });
/**
 * Get portfolio outreach message templates
 */
export const v2GetPortfolioOutreachMessages = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/portfolio/messages', ...options });
/**
 * Update portfolio outreach message templates
 */
export const v2UpdatePortfolioOutreachMessages = (options) => (options.client ?? client).patch({
    url: '/api/v2/startups/{id}/outreach/portfolio/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Drop the founder edit for one portfolio message and use the generated version
 */
export const v2ResetPortfolioOutreachMessage = (options) => (options.client ?? client).delete({ url: '/api/v2/startups/{id}/outreach/portfolio/messages/{field}/custom', ...options });
/**
 * Mark portfolio outreach messages as reviewed
 */
export const v2ReviewPortfolioOutreachMessages = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/portfolio/messages/review', ...options });
/**
 * Get portfolio contacts for pre-launch approval board
 */
export const v2GetPortfolioContactPreviews = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/portfolio/contacts', ...options });
/**
 * Save approve/decline decisions for portfolio contacts
 */
export const v2SetPortfolioContactDecisions = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{id}/outreach/portfolio/contacts/decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Approve the portfolio contact list and proceed to launch
 */
export const v2ApprovePortfolioContacts = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/portfolio/contacts/approve', ...options });
/**
 * Launch the portfolio outreach campaign
 */
export const v2LaunchPortfolioCampaign = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/portfolio/launch', ...options });
/**
 * Get portfolio outreach kanban queue
 */
export const v2GetPortfolioQueue = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/portfolio/queue', ...options });
/**
 * Skip every founder still awaiting approval, keeping them restorable
 */
export const v2SkipAllPortfolioQueued = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/portfolio/queue/skip-all', ...options });
/**
 * Archive a finished portfolio outreach message
 */
export const v2ArchivePortfolioMessage = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/portfolio/queue/{messageId}/archive', ...options });
/**
 * List archived portfolio founders (skipped, declined, engaged, no response)
 */
export const v2GetPortfolioArchive = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/outreach/portfolio/archive', ...options });
/**
 * Restore an archived portfolio founder back onto the board
 */
export const v2RestorePortfolioArchived = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/outreach/portfolio/archive/{messageId}/restore', ...options });
/**
 * Confirm or dismiss a warm intro candidate
 */
export const v2SubmitPortfolioWarmIntroDecision = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{id}/outreach/portfolio/queue/{messageId}/warm-intro',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Get wallet balance + lifetime totals
 */
export const v2GetStartupWallet = (options) => (options.client ?? client).get({ url: '/api/v2/startups/{id}/wallet', ...options });
/**
 * Start a Stripe Checkout flow for a wallet top-up
 */
export const v2CreateWalletTopUpCheckout = (options) => (options.client ?? client).post({
    url: '/api/v2/startups/{id}/wallet/topup/checkout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Open the Stripe Customer Portal for wallet billing
 */
export const v2OpenWalletBillingPortal = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/wallet/billing-portal', ...options });
/**
 * Request a withdrawal of the wallet balance (emails ops)
 */
export const v2RequestWalletWithdrawal = (options) => (options.client ?? client).post({ url: '/api/v2/startups/{id}/wallet/request-withdrawal', ...options });
/**
 * HeyReach: lead profile viewed (warm-up)
 */
export const v2WebhookHeyreachViewedProfile = (options) => (options.client ?? client).post({
    url: '/api/v2/webhooks/heyreach/{token}/viewed-profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * HeyReach: lead post liked (warm-up)
 */
export const v2WebhookHeyreachLikedPost = (options) => (options.client ?? client).post({
    url: '/api/v2/webhooks/heyreach/{token}/liked-post',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * HeyReach: connection request sent
 */
export const v2WebhookHeyreachConnectionRequestSent = (options) => (options.client ?? client).post({
    url: '/api/v2/webhooks/heyreach/{token}/connection-request-sent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * HeyReach: connection request accepted
 */
export const v2WebhookHeyreachConnectionAccepted = (options) => (options.client ?? client).post({
    url: '/api/v2/webhooks/heyreach/{token}/connection-accepted',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * HeyReach: first message reply
 */
export const v2WebhookHeyreachMessageReply = (options) => (options.client ?? client).post({
    url: '/api/v2/webhooks/heyreach/{token}/message-reply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * HeyReach: every message reply
 */
export const v2WebhookHeyreachEveryMessageReply = (options) => (options.client ?? client).post({
    url: '/api/v2/webhooks/heyreach/{token}/every-message-reply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * HeyReach: campaign completed per lead
 */
export const v2WebhookHeyreachCampaignCompleted = (options) => (options.client ?? client).post({
    url: '/api/v2/webhooks/heyreach/{token}/campaign-completed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Founder profile/evaluation context for the Intercom Fin chatbot
 */
export const v2GetFinFounderContext = (options) => (options.client ?? client).get({ url: '/api/v2/integrations/intercom/fin/founder-context', ...options });
/**
 * Handle Stripe webhook events
 */
export const v2StripeWebhook = (options) => (options?.client ?? client).post({ url: '/api/v2/webhooks/stripe', ...options });
/**
 * Receive a message sent to a startup updates address (Resend inbound)
 */
export const v2WebhookResendInbound = (options) => (options?.client ?? client).post({ url: '/api/v2/webhooks/resend/inbound', ...options });
